import { BsShare, BsGetEnv } from 'dida-web-common'

// 常量定义
const QUERY_PARAMETERS = 'cid&access_token&_iadid&_iidid&key_sign&ad_position&ad_location&share'

/**
 * 清理 URL 中的指定参数
 * @param {string} url - 原始 URL
 * @param {string[]} parameters - 需要清理的参数列表
 * @returns {string} - 清理后的 URL
 */
const cleanUrlParameters = (url, parameters) => {
    const [baseUrl, queryString] = url.split('?')
    if (!queryString) return baseUrl

    const params = queryString.split('&').filter(param => {
        const key = param.split('=')[0]
        return !parameters.includes(key)
    })

    return params.length > 0 ? `${baseUrl}?${params.join('&')}` : baseUrl
}

/**
 * 生成分享链接
 * @param {Object} shareConfig - 分享配置
 * @param {string} itemTypes - 项目类型
 */
export default (shareConfig = {}, itemTypes) => {
    let url = shareConfig.url || window.location.href

    // 处理 useHash 参数
    if (url.includes('useHash=true')) {
        url = url.split('#')[0]
    }

    // 清理 URL 中的指定参数
    const parametersToRemove = QUERY_PARAMETERS.split('&')
    url = cleanUrlParameters(url, parametersToRemove)

    // 添加 share 参数
    url += url.includes('?') ? '&share=true' : '?share=true'

    // 如果分享开关开启且 URL 存在，生成分享对象
    if (shareConfig.switch && url) {
        const shareData = {
            title: shareConfig.title,
            desc: shareConfig.desc,
            imgUrl: shareConfig.imgUrl,
            showChannel: shareConfig.showChannel.toString()
        }

        const shareObj = {
            data: shareData,
            shareByAppMinPg: {
                enable: shareConfig.appShareSwitch
            },
            shareByMinipg: {
                enable: true,
                link: `/pagesWebView/webViewActivity/webViewActivity?baseUrl=${encodeURIComponent(url)}`,
                imgUrl: shareConfig.imgUrl
            },
            shareByWx: {
                enable: true
            },
            shareByDingtalk: {
                enable: true
            }
        }

        // 处理 miniPgShareSwitch 逻辑
        if (shareConfig.miniPgShareSwitch === 0) {
            shareObj.data.link = url
        }

        // 处理 circleUrl 逻辑
        if (shareConfig.circleUrl) {
            shareObj.data.imgUrl = shareConfig.circleUrl
        }

        // 处理 miniPgShareSwitch 不为 0 的逻辑
        if (shareConfig.miniPgShareSwitch !== 0) {
            const miniPgShare = {
                minipgThumbnail: shareConfig.imgUrl,
                minipgTitle: shareConfig.title,
                minipgDes: shareConfig.desc,
                minipgLink: `/pagesWebView/webViewActivity/webViewActivity?baseUrl=${encodeURIComponent(url)}`,
                minipgWithShareTicket: true,
                minipgType: BsGetEnv.isEnvOnline ? 0 : 2, // 体验版
                minipgUserName: shareConfig.miniPgShareSwitch
            }
            shareObj.data = { ...shareObj.data, ...miniPgShare }
        }

        // 初始化分享
        new BsShare(shareObj)
    }
}
